import { SIZE_FULL } from '@/lib/gridElements/size';

import { HeatMapChart } from '@/components/composite/Charts/HeatMapChart';

export const followersOnlineConfig = {
    title: 'chart.tiktok.followers_online',
    minWidth: 750,
    name: {
        day: 'chart.tiktok.followers_online_more',
        value: 'chart.tiktok.followers_online_less'
    },
    datePickerDoesNotApply: true,
    noTableView: true,
    color: {
        value: 'white'
    },
    id: 'followers_online',
    colors: {
        light: {
            yellow100: '#ffeec8',
            yellow150: '#ffe09b',
            yellow200: '#ffd880',
            yellow400: '#ffb81a',
            yellow: '#ff9300',
            red: '#ee3034'
        },
        dark: {
            yellow100: '#433317',
            yellow150: '#6F563B',
            yellow200: '#9D774A',
            yellow400: '#CA985A',
            yellow: '#f8b96a',
            red: '#ff7679'
        }
    },
    tooltipTranslation: {
        token: 'chart.tiktok.followers_online_tooltip_chart',
        values: ['date', 'day', 'value']
    },
    legendHighlightValueTranslation: {
        token: 'chart.tiktok.followers_online_legend_highlight',
        values: ['date', 'day']
    },
    tooltip: 'chart.tiktok.followers_online_tooltip',
    size: SIZE_FULL,
    type: 'chart',
    iconHighestValue: 'star',
    margin: { bottom: 10, left: -30 },
    breakpoints: [
        { color: 'yellow100', r: 3.5 },
        { color: 'yellow150', r: 7.5 },
        { color: 'yellow200', r: 12.5 },
        { color: 'yellow400', r: 12.5 },
        { color: 'yellow', r: 12.5 },
        { color: 'red', r: 12.5 }
    ],
    element: HeatMapChart
};
